import React from "react";
import { Facebook, Twitter } from ".";

export default function({type, className}) {
    let Icon = undefined;

    switch (type) {
        case 'facebook':
            Icon = Facebook;
            break;
        case 'twitter':
            Icon = Twitter;
            break;
    }

    return <Icon
        style={{margin: -4}}
        className={className}
    />;
};